{
    "maps": {
        "href": "../maps/",
        "title": "Visualization of models fields",
        "innerHTML": "Maps",
        "display": "block"
    },
    "evaluation": {
        "href": "../evaluation/",
        "title": "Single model evaluation against observations",
        "innerHTML": "Evaluation",
        "display": "block"
    },
    "intercomp": {
        "href": "../intercomp/",
        "title": "Multiple model evaluation against observations",
        "innerHTML": "Intercomparison",
        "display": "block"
    },
    "overall": {
        "href": "../overall/",
        "title": "Overview of models evaluation",
        "innerHTML": "Overall Evaluation",
        "display": "block"
    },
    "infos": {
        "href": "../infos/",
        "title": "Information on datasets, statistics and experiment",
        "innerHTML": "Information",
        "display": "block"
    },
    "reports": {
        "href": "../reports/",
        "title": "Evaluation Reports",
        "innerHTML": "Reports",
        "display": "none"
    }
}